var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hero-page", class: _vm.className, style: _vm.style },
    [
      _vm.$slots["infobox"] && !_vm.infoBoxHoldout
        ? _c(
            "div",
            { ref: "infoBox", staticClass: "infobox", style: _vm.infoBoxStyle },
            [_vm._t("infobox", null, { item: _vm.spotlight })],
            2
          )
        : _vm.spotlight && !_vm.infoBoxHoldout
        ? _c(
            "div",
            { ref: "infoBox", staticClass: "infobox", style: _vm.infoBoxStyle },
            [
              _c("h2", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.spotlight.Name)),
              ]),
              _vm.spotlight.IngressText
                ? _c("div", {
                    staticClass: "ingress-text",
                    domProps: { innerHTML: _vm._s(_vm.spotlight.IngressText) },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.nextImageSrc
        ? _c("img", {
            staticClass: "preload-image",
            attrs: { src: _vm.nextImageSrc },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }